(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name AsesoramientoService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('AsesoramientoService', AsesoramientoService);

    AsesoramientoService.$inject = ["$http","$q","$window","$location"];

    function AsesoramientoService($http,$q,$window,$location){  

        var asesoramiento = {
            SaveAsesoramiento:SaveAsesoramiento,
            GetChat:GetChat,
            GetAsesoramientos:GetAsesoramientos,
            GetMensajesAsesoramiento:GetMensajesAsesoramiento,
            getProductosAsesoramiento:getProductosAsesoramiento
        };

        function SaveAsesoramiento(vm){
            var config = {
                headers : {}
            }

            return $http.post('/ajax/asesoramiento', { 
                titulo:vm.titulo,
                descripcion:vm.descripcion,
                archivos:JSON.stringify(vm.ficheros),
                estado_id:vm.estado_id
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function GetChat(vm){
            var config = {
                headers : {}
            }

            return $http.post('/ajax/mensajes', { 
                //Mensajes(vm) en singular para no repetir nombres
                mensajes:vm.mensaje,
                archivos_chat:JSON.stringify(vm.ficheros),
                asesoramiento_id:vm.asesoramiento_activo.id,
                fecha:vm.fecha

             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function GetAsesoramientos(vm){
            var config = {
                headers : {}
            }
            return $http.get('/ajax/getasesoramientos', { params : { 
                estado:vm.estado,
                buscador:vm.buscador,
                limit:vm.limit
            } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
            var config = {
                headers : {}
            }

        };

        function getProductosAsesoramiento(vm){
            var config = {
                headers : {}
            }
            return $http.get('/ajax/getproductosasesoramiento', { params : { 
            } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
            var config = {
                headers : {}
            }

        };

        function GetMensajesAsesoramiento(asesoramiento_id){

            var config = {
                headers : {}
            }

            return $http.get('/ajax/asesoramientoactivo', { params : { asesoramiento_id:asesoramiento_id } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        return asesoramiento;
    }

})();

